{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Átirányítás operátorhoz",
    "MESSAGE": "Kapcsoljanak egy operátorhoz"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Letöltés",
      "UPLOADING": "Frissítés..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Elküldés"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Üzenet elküldése újból",
      "ERROR_MESSAGE": "Nem sikerült az elküldés, kérjük próbáld később"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Értékelje a válasz minőségét"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Kérjük, várja meg, amíg csatlakozik az ügynök"
  },
  "ROBOT_CHECK": {
    "TITLE": "Gyors biztonsági ellenőrzés",
    "DESCRIPTION": "Kérjük, végezze el az alábbi ellenőrzést.",
    "VERIFYING": "Ellenőrzés…",
    "ERROR": "Ez nem sikerült. Kérjük, próbálja újra.",
    "RETRY": "Próbálja újra"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Online vagyunk",
    "OFFLINE": "Jelenleg nem vagyunk elérhetőek",
    "ONLINE_WITH_BOT": "A csapat és a mesterséges intelligencia segítőnk elérhető",
    "OFFLINE_WITH_BOT": "A mesterséges intelligencia segítőnk itt van, hogy segítsen",
    "BOT_ONLY_REPLY": "Azonnali válasz"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Néhány percen belül válaszol",
    "IN_A_FEW_HOURS": "Néhány órán belül válaszol",
    "IN_A_DAY": "Általánban egy napon belül válaszol",
    "BACK_IN": "Legközelebb online leszünk ekkor:"
  },
  "DAY_NAMES": {
    "SUNDAY": "vasárnap",
    "MONDAY": "hétfő",
    "TUESDAY": "kedd",
    "WEDNESDAY": "szerda",
    "THURSDAY": "csütörtök",
    "FRIDAY": "péntek",
    "SATURDAY": "szombat"
  },
  "START_CONVERSATION": "Beszélgetés megkezdése",
  "END_CONVERSATION": "Beszélgetés befejezése",
  "CONTINUE_CONVERSATION": "Beszélgetés folytatása",
  "YOU": "Ön",
  "START_NEW_CONVERSATION": "Új beszélgetés megkezdése",
  "RESOLVE_LATER": "Ezt a témát e-mailben/telefonon oldjuk meg. Most szeretnék valami másról kérdezni.",
  "VIEW_UNREAD_MESSAGES": "Olvasatlan üzenetei vannak",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Új üzenetek",
    "CLOSE_MESSAGES_BUTTON": "Bezárás",
    "COMPANY_FROM": "innen",
    "BOT": "Bot"
  },
  "BUBBLE": {
    "LABEL": "Chatelj velünk"
  },
  "POWERED_BY": "Üzemelteti: {brandName}",
  "EMAIL_PLACEHOLDER": "Add meg az e-mailed",
  "CHAT_PLACEHOLDER": "Gépeld be üzeneted",
  "TODAY": "Ma",
  "YESTERDAY": "Tegnap",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Teljes név",
        "PLACEHOLDER": "Kérjük a teljes nevedet add meg",
        "REQUIRED_ERROR": "A teljes név megadása kötelező"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Email cím",
        "PLACEHOLDER": "Kérjük helyes e-mailcímet adj meg",
        "REQUIRED_ERROR": "Email cím megadása kötelező",
        "VALID_ERROR": "Kérjük helyes e-mailcímet adj meg"
      },
      "PHONE_NUMBER": {
        "LABEL": "Telefonszám",
        "PLACEHOLDER": "Kérlek add meg a telefonszámod",
        "REQUIRED_ERROR": "Telefonszám megadása kötelező",
        "DIAL_CODE_VALID_ERROR": "Kérlek válassz országot",
        "VALID_ERROR": "Kérlek egy valós telefonszámot adj meg",
        "DROPDOWN_EMPTY": "Nincs találat",
        "DROPDOWN_SEARCH": "Ország keresése"
      },
      "MESSAGE": {
        "LABEL": "Üzenet",
        "PLACEHOLDER": "Írd be az üzeneted",
        "ERROR": "Az üzenet túl rövid"
      }
    },
    "CAMPAIGN_HEADER": "Kérjük a beszélgetés megkezdése előtt add meg neved és e-mail címed",
    "IS_REQUIRED": "kötelező",
    "REQUIRED": "Kötelező",
    "REGEX_ERROR": "Kérlek, adj meg érvényes értéket"
  },
  "FILE_SIZE_LIMIT": "A file mérete meghaladja a {MAXIMUM_FILE_UPLOAD_SIZE} limitet",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Érvénytelen mező"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Emoji keresése",
    "NOT_FOUND": "Nem található emoji",
    "ARIA_LABEL": "Emojiválasztó"
  },
  "CSAT": {
    "TITLE": "Értékeld a beszélgetést",
    "SUBMITTED_TITLE": "Köszönjük, hogy elküldted az értékelést",
    "PLACEHOLDER": "Mondj nekünk többet..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Beszélgetés kivonat igénylése",
    "SEND_EMAIL_SUCCESS": "A beszélgetés jegyzet sikeresen elküldve",
    "SEND_EMAIL_ERROR": "Hiba történt, kérjük próbáld újra"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Népszerű cikkek",
    "VIEW_ALL_ARTICLES": "Mutasd az összes bejegyzést",
    "IFRAME_LOAD_ERROR": "Hiba történt a cikk betöltése során, kérjük, frissítse az oldalt, és próbálja meg újra."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Megnyitás",
      "BUY": "Vásárlás"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Képüzenet"
    },
    "audio": {
      "CONTENT": "Hangüzenet"
    },
    "video": {
      "CONTENT": "Videoüzenet"
    },
    "file": {
      "CONTENT": "Csatolt file"
    },
    "location": {
      "CONTENT": "Hely"
    },
    "fallback": {
      "CONTENT": "megosztott URL-t tartalmaz"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Válaszolva a következőre:"
  }
}
